import script from "./UserConfirmComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserConfirmComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserConfirmComponent.vue?vue&type=style&index=0&id=7a0e8555&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a0e8555"]])

export default __exports__